export default {"src":"/_next/static/media/GetZenadmin.de97858d.svg","height":316,"width":194,"blurWidth":0,"blurHeight":0};